export function buildModuleRegistrationPayload({
  selectedHdi,
  baremodules,
  moduleType,
  tbpxLayer,
  requiresLayer,
  shortName,
  gluingDate,
  gluingLocation,
  wirebondingDate,
  wirebondingLocation,
  coatingDate,
  coatingLocation,
  mechanicalStatus,
  status,
  rotation,
  comments,
}) {
  const payload = {
    hdi: selectedHdi,
    baremodules,
    kind_of_part: moduleType,
    short_name: shortName,
    gluing_date: gluingDate,
    gluing_location: gluingLocation,
    mechanical_status: mechanicalStatus,
    status,
    is_rotated: rotation === "" ? null : rotation === "true",
    comments,
  };
  if (requiresLayer) payload.layer = tbpxLayer;
  if (wirebondingDate && wirebondingLocation) {
    payload.wirebonding_date = wirebondingDate;
    payload.wirebonding_location = wirebondingLocation;
  }
  if (coatingDate && coatingLocation) {
    payload.coating_date = coatingDate;
    payload.coating_location = coatingLocation;
  }
  return payload;
}
